var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecondarySvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6543 8.87988H6.92609C6.55323 8.87988 6.25098 9.19355 6.25098 9.58048V25.7919C6.25098 26.1789 6.55323 26.4925 6.92609 26.4925H21.6543C22.0271 26.4925 22.3294 26.1789 22.3294 25.7919V9.58048C22.3294 9.19355 22.0271 8.87988 21.6543 8.87988Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.414 7.13696H5.16584C4.97663 7.13696 4.82324 7.29614 4.82324 7.49249V8.52422C4.82324 8.72058 4.97663 8.87975 5.16584 8.87975H23.414C23.6032 8.87975 23.7566 8.72058 23.7566 8.52422V7.49249C23.7566 7.29614 23.6032 7.13696 23.414 7.13696Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16602 7.13702L14.2918 1.05469L23.4142 7.13702",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0552 11.604H9.59992C9.34949 11.604 9.14648 11.8147 9.14648 12.0746V15.0373C9.14648 15.2972 9.34949 15.5079 9.59992 15.5079H12.0552C12.3056 15.5079 12.5086 15.2972 12.5086 15.0373V12.0746C12.5086 11.8147 12.3056 11.604 12.0552 11.604Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3003 11.604H16.845C16.5946 11.604 16.3916 11.8147 16.3916 12.0746V15.0373C16.3916 15.2972 16.5946 15.5079 16.845 15.5079H19.3003C19.5507 15.5079 19.7537 15.2972 19.7537 15.0373V12.0746C19.7537 11.8147 19.5507 11.604 19.3003 11.604Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5009 17.9316H13.1464C12.8681 17.9316 12.6426 18.1657 12.6426 18.4545V22.2363C12.6426 22.5251 12.8681 22.7592 13.1464 22.7592H15.5009C15.7791 22.7592 16.0047 22.5251 16.0047 22.2363V18.4545C16.0047 18.1657 15.7791 17.9316 15.5009 17.9316Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4857 22.7559H11.1611V24.6137H17.4857V22.7559Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7856 24.6172H9.86133V26.4924H18.7856V24.6172Z",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25415 20.9609C5.68742 21.4144 4.99147 21.6597 4.27579 21.658C3.41528 21.658 2.59004 21.3033 1.98156 20.6718C1.37309 20.0404 1.03125 19.184 1.03125 18.291C1.03125 17.398 1.37309 16.5415 1.98156 15.91C2.59004 15.2786 3.41528 14.9238 4.27579 14.9238C4.99147 14.9222 5.68742 15.1674 6.25415 15.621",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27539 21.6614V26.4924",
    stroke: "#2C2E3E",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondarySvg);
export default __webpack_public_path__ + "static/media/SecondarySvg.3a64d530.svg";
export { ForwardRef as ReactComponent };